export default {
	firestorePath: "organisations",
	firestoreRefType: "collection",
	moduleName: "organisations",
	statePropName: "data",
	namespaced: true,
	state: {
	},
	getters: {
	},
	mutations: {
	},
	actions: {
	},
};
